define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'countdown',
  'es6!sumo/util',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, _, countdown, Util, Component) => {
  const VALID_STYLE_ATTRS = [
    'color',
    'paddingTop',
    'paddingBottom',
    'background',
    'backgroundColor',
    'fontFamily',
    'fontWeight',
    'fontStyle',
    'fontSize',
    'textAlign',
    'borderTopWidth',
    'borderLeftWidth',
    'borderBottomWidth',
    'borderRightWidth',
    'borderColor',
    'borderStyle',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'lineHeight',
    'boxShadow',
    'textShadow',
    'letterSpacing',
  ];

  const { containsPrize } = Util;

  @Component({ disableVerticalResize: true })
  class Text extends React.Component {
    static propTypes = {
      text: PropTypes.string.isRequired,
      style: PropTypes.instanceOf(Object).isRequired,
      discountCode: PropTypes.string.isRequired,
      isPreview: PropTypes.bool.isRequired,
      winningOption: PropTypes.instanceOf(Immutable.Map).isRequired,
      onMouseEnter: PropTypes.func.isRequired,
      onMouseLeave: PropTypes.func.isRequired,
      format: PropTypes.string.isRequired,
      currentStep: PropTypes.string.isRequired,
      end: PropTypes.string.isRequired,
    };

    static defaultProps = {
      style: Immutable.Map(),
    }

    constructor(props) {
      super(props);
      const { end } = this.props;

      this.state = {
        timeRemaining: countdown(new Date(), new Date(end)),
        fadeToast: false,
      };

      this.updateTimeRemaining = this.updateTimeRemaining.bind(this);
      this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
      const { text } = this.props;
      if (text.indexOf('{timer}') > -1) {
        this.timer = setInterval(() => {
          const { end } = this.props;
          this.updateTimeRemaining(end);
        }, 1000);
      }
    }

    componentWillReceiveProps(nextProps) {
      const { end } = nextProps;
      this.updateTimeRemaining(end);
    }

    componentWillUnmount() {
      const { text } = this.props;
      if (text.indexOf('{timer}') === -1) return;
      clearInterval(this.timer);
    }

    onClick(event) {
      const { text, discountCode, isPreview, winningOption } = this.props;
      const { fadeToast } = this.state;

      const copyToClipboard = (
        containsPrize(text) &&
        (
          discountCode ||
          (winningOption && winningOption.get('prizeType') === 'discount')
        )
      );

      if (isPreview || !copyToClipboard) return;
      event.preventDefault();

      // Create textarea to copy text from
      if (discountCode) {
        Util.copyToClipboard(discountCode);
      }

      // Copy to clipboard and replace text
      this.setState({ copied: true });

      if (fadeToast === 'in') {
        setTimeout(() => this.setState({ fadeToast: 'out' }), 1000);
      } else {
        this.setState({ fadeToast: 'in' });
        setTimeout(() => this.setState({ fadeToast: 'out' }), 2000);
      }
    }

    updateTimeRemaining(end) {
      const { timeRemaining } = this.state;
      const newTimeRemaining = countdown(new Date(), new Date(end));

      if (timeRemaining !== newTimeRemaining) {
        this.setState({ timeRemaining: newTimeRemaining });
      }
    }

    renderFieldToast() {
      const { text, isPreview } = this.props;
      const { fadeToast } = this.state;

      const copyToClipboard = containsPrize(text);

      if (isPreview || !copyToClipboard) return null;

      let className = 'listbuilder-popup-field-toast';
      const toastText = 'Your discount code has been copied!';

      if (fadeToast !== false) {
        className += ` listbuilder-popup-field-toast-fade-${fadeToast}`;
      }

      return (
        <div className={className}>{toastText}</div>
      );
    }

    render() {
      const {
        onMouseEnter,
        onMouseLeave,
        format,
        currentStep,
        winningOption,
        discountCode,
        discount,
        isPreview,
      } = this.props;

      const { timeRemaining } = this.state;
      let text = this.props.text;
      const style = _.pick(this.props.style.toJS(), VALID_STYLE_ATTRS);

      const hasPadding = !!(style.paddingTop || style.paddingBottom);
      if (!hasPadding) {
        style.padding = '0';
      }
      style.margin = '0';

      const hasLetterSpacing = !!style.letterSpacing;
      if (!hasLetterSpacing) {
        style.letterSpacing = 'normal';
      }

      // Filter out newlines to keep component consistent between wysiwyg and preview
      text = text.replace(/\n/g, '');

      if (text.indexOf('{timer}') > -1 && format) {
        text = text.replace(/{timer}/g, Util.formatTime(timeRemaining, format));
      }

      // {query:discount} should be replaced before making it here,
      // but this is to make previews look better (shortcuts)
      const tags = {
        'query:discount': discountCode || '{query:discount}',
        discount_amount: (discount) ? discount.amount : '',
        price_diff: (discount) ? discount.priceDiff : '',
        next_discount_amount: (discount && discount.nextDiscount) ? discount.nextDiscount.amount : '',
        next_price_diff: (discount && discount.nextDiscount) ? discount.nextDiscount.priceDiff : '',
      };

      Object.keys(tags).forEach((tag) => {
        if (text.indexOf(`{${tag}}`) > -1) {
          text = text.replace(new RegExp(`{${tag}}`, 'g'), tags[tag]);
        }
      });

      // Preview only
      text = text.replace(/{query:discount-({shortId}|[0-9a-fA-F]{8})}/, discountCode || 'ABC-123');

      if (currentStep === 'success' && !isPreview) {
        const prizeType = winningOption ? winningOption.get('prizeType') : null;

        if (text.indexOf('{game_result}') > -1 && winningOption) {
          text = text.replace(/{game_result}/g, winningOption.get('resultText') || '{game_result}');
        }

        if (text.indexOf('{prize_text}') > -1 && winningOption) {
          text = text.replace(/{prize_text}/g, winningOption.get('label') || '{prize_text}');
        }

        if (containsPrize(text)) {
          if (prizeType === 'discount' || discountCode) {
            text = text.replace(/{discount}/g, discountCode || '{discount}');
            text = text.replace(/{discount_code}/g, discountCode || '{discount_code}');
            text = text.replace(/{prize}/g, discountCode || '{prize}');

            if (!isPreview) style.cursor = 'pointer';
          } else if (prizeType === 'content') {
            let el = '{prize}';
            if (!isPreview) {
              el = `<a href="${winningOption.get('mediaSrc')}">Download Prize</a>`;
              style.cursor = 'pointer';
            }

            text = text.replace(/{prize}/g, el);
          }
        }
      }

      // We have to use dangerously set innerhtml since we want the user to have the
      // ability to use html in the text.
      return (
        <div
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          onClick={this.onClick}
          role="button"
          tabIndex={0}
        >
          <p
            ref={(el) => { this.textEl = el; }}
            style={style}
            dangerouslySetInnerHTML={{ __html: text }}
          />
          {this.renderFieldToast()}
        </div>
      );
    }
  }

  return Text;
});
